import { IConfiguration } from "../../domain/configuration";
import { ILocalhostRegistry } from "../../domain/localhost";
import { ISystemRegistry, IClipboardService, instanceOfIClipboardServiceOwnable, ISuggestRepository, ILogRepository, IManagementTokenRepository } from "../../domain/system";
import { ClipboardService } from "./ClipboardService";
import { SuggestRepository } from "./SuggestRepository";
import { LogRepository } from "./LogRepository";
import { ManagementTokenRepository } from "./ManagementTokenRepository";

export class SystemRegistry implements ISystemRegistry {
  constructor(private _getConfiguration: () => IConfiguration, private _getToken: () => string, private _localhostRegistry: ILocalhostRegistry) {
  }

  getClipboardService(): IClipboardService {
    const configuration = this._getConfiguration();
    return (instanceOfIClipboardServiceOwnable(this._localhostRegistry) && configuration.behavior.localhost.isEnable && configuration.behavior.localhost.clipboard.isEnable)
      ? this._localhostRegistry.getClipboardService()
      : new ClipboardService();
  }

  getSuggestRepository(): ISuggestRepository {
    return new SuggestRepository(this._getToken);
  }

  getLogRepository(): ILogRepository {
    return new LogRepository(this._getToken);
  }

  getManagementTokenRepository(): IManagementTokenRepository {
    return new ManagementTokenRepository(this._getToken);
  }
}
